<template>
    <div>
        <ModalCommon :id="`ModalAnalyticsDetail`" :config="configModal" @close="onHandleClose" @save="onHandleSave">
            <div class="form-group row">
                <label class="col-sm-3"
                    >{{ $t('managerForm.temporarily.nameTemp') }}
                    <span v-if="onHandleCheckFieldRequired(initConfigField.configFieldNameTemp.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <InputText
                        :model.sync="initForm.name"
                        :config.sync="initConfigField.configFieldNameTemp"
                        @blur="handleValidateField(initConfigField.configFieldNameTemp)"
                    />
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText } from '@/components/Input';
import { initForm, initConfig } from './constants';
import { validateField, validateAllField } from '@/utils/validate';
import { onHandleCheckFieldRequired } from '@/utils/handlers';

import ModalCommon from '@/components/Modal/main.vue';

export default {
    name: 'ModalTemporarily',
    components: {
        ModalCommon,
        InputText
    },
    props: {
        configModal: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            initForm: initForm(),
            initConfigField: initConfig()
        };
    },
    methods: {
        onHandleCheckFieldRequired,

        onHandleClose() {
            this.initForm = initForm();
            this.initConfigField = initConfig();
        },

        onHandleSave() {
            let check = validateAllField(this.initConfigField);
            if (!check) return;
            this.configModal.model = false;
            this.$emit('save', this.initForm);
            this.initForm = initForm();
            this.initConfigField = initConfig();
        },

        handleValidateField(configField) {
            validateField(configField);
        }
    }
};
</script>

<style lang="scss" scoped></style>
